const PREFIXES = {
	bo: 'Best of',
	pa: 'Play All',
}

/**
 * Turns a match type value into a readable label.
 *
 * "Bo3"        -> "Best of 3"
 * "Bo5 - ABBA" -> "Best of 5"
 * "Pa4 - 3v3"  -> "Play All 4"
 *
 * Anything unrecognised is returned untouched.
 */
export function prettyMatchType(matchType) {
	if (!matchType) return ''

	// Drop the " - 2v2" / " - 3v3" / " - ABBA" suffix
	const base = String(matchType).split(' - ')[0].trim()

	const match = base.match(/^(bo|pa)(\d+)$/i)
	if (!match) return String(matchType)

	const [, prefix, count] = match

	return `${PREFIXES[prefix.toLowerCase()]} ${count}`
}

export default prettyMatchType
